import {Component, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {NgIf} from "@angular/common";
import {firstValueFrom, forkJoin} from "rxjs";
import {CustomTitle} from 'lib-base';
import {FormsModule} from "@angular/forms";
import dayjs from 'dayjs';
import {MessageService} from "primeng/api";
import {TabViewModule} from "primeng/tabview";
import {DashboardGeneralTramitesComponent} from "./dashboard-general-tramites/dashboard-general-tramites.component";
import {DashboardGeneralPqrsdfComponent} from "./dashboard-general-pqrsdf/dashboard-general-pqrsdf.component";
import {FilterDashboardComponent} from "../filter-dashboard/filter-dashboard.component";
import {FilterDatesEvent} from "../../../shared/interfaces/database/configuracion";
import {FilterDashboardService} from "../filter-dashboard/filter-dashboard.service";


@Component({
  selector: 'app-dashboard-general',
  standalone: true,
  imports: [
    FormsModule,
    TabViewModule,
    FilterDashboardComponent,
    DashboardGeneralTramitesComponent,
    DashboardGeneralPqrsdfComponent,
  ],
  templateUrl: './dashboard-general.component.html',
  styleUrl: './dashboard-general.component.scss'
})
export class DashboardGeneralComponent implements OnInit {

  translations: any = {};
  fechaInicial: Date = dayjs().startOf('year').toDate();
  fechaFinal: Date = new Date();
  readonly maxDate: Date = new Date();

  constructor(
    private _t: TranslateService,
    public messageService: MessageService,
    private filterDateService: FilterDashboardService
  ) {
  }

  ngOnInit() {
    this.translate();
  }

  private async translate(): Promise<void> {
    this.translations = await firstValueFrom(forkJoin({
      filter: this._t.get('components.dashboard-general.filtros'),
      tramRecibidos: this._t.get('components.dashboard-general.tramites-recibidos'),
      solicitudesRecibidas: this._t.get('components.dashboard-general.solicitudes-recibidas'),
      warnSummary: this._t.get('form.msg.warn-summary'),
      detailWarn: this._t.get('components.dashboard-general.advertencia-detalle'),
      placeholderStartDate: this._t.get('components.dashboard-general.placeholder-fecha-inicial'),
      placeholderEndDate: this._t.get('components.dashboard-general.placeholder-fecha-final'),
      tabTramites: this._t.get('components.dashboard-general.tab-tramites'),
      tabPqrsdf: this._t.get('components.dashboard-general.tab-pqrsdf'),
    }));
  }

  onFilterDates(event: FilterDatesEvent) {
    if (event.startDate) {
      this.fechaInicial = new Date(event.startDate);
    }
    if (event.endDate) {
      this.fechaFinal = new Date(event.endDate);
    }
  }

}
